import { axios } from './commons';

export default {
  login: ({ email, password, turnstileResponse = null }) =>
    axios.post('/auth/login', { email, password, turnstileResponse }),
  loginWithoutCaptcha: ({ email, password }) =>
    axios.post('/auth/login', { email, password }),
  forgetPassword: ({ email }) => axios.post('/auth/forget-password', { email }),
  resetTokenCheck: ({ token }) => axios.get(`/auth/reset/${token}`),
  resetPassword: ({ token, password }) =>
    axios.post(`/auth/reset/${token}`, { password }),
  logout: () => axios.post('/auth/logout'),
  generateLoginLink: (userId) =>
    axios.post(`/auth/${userId}/generate-login-link`),
};
